import { render, staticRenderFns } from "./InstallationDetail.vue?vue&type=template&id=27c846ff&scoped=true&"
import script from "./InstallationDetail.vue?vue&type=script&lang=js&"
export * from "./InstallationDetail.vue?vue&type=script&lang=js&"
import style0 from "./InstallationDetail.vue?vue&type=style&index=0&id=27c846ff&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c846ff",
  null
  
)

export default component.exports